export enum TeamTypeSettingsGuestAccess {
	DeterminedByApplicant,
	NoAccess,
	Access,
}
